﻿import EventCourseObject from '@model/EventCourseObject'
import Event from '@model/Event'
import { Model } from "pinia-orm"
import { BelongsTo, HasMany, OnDelete, Str, Uid } from "pinia-orm/decorators"

export default class EventCourse extends Model {
    static entity = 'events-courses'

    @Uid() declare id: string
    @Uid() declare eventId: string
    @BelongsTo( () => Event, 'eventId' ) declare event: Event
    @Str( null ) declare title: string
    @HasMany( () => EventCourseObject, 'eventCourseId' ) @OnDelete( 'cascade' ) declare objects: EventCourseObject[]

    get dump () {
        return {
            title: this.title,
            objects: this.objects.map( obj => obj.dump )
        }
    }

    static piniaOptions = {
        persist: true
    }
}
